export const UPDATE_EMAIL_MUTATION = `
  mutation UpdateEmailMutation($input: updateEmailInput!) {
    me {
      updateEmail(input: $input) {
        id
      }
    }
  }
`;
